import React from "react";
import classNames from "classnames";
import { Form, Input } from "rsuite";
import { ORDER_FORM_FIELD_PROPS } from "./orderFormRsuite";
import styles from "./orderForm.module.scss";

type OrderLabeledTextareaProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  className?: string;
  controlId?: string;
};

const OrderLabeledTextarea: React.FC<OrderLabeledTextareaProps> = ({
  label,
  value,
  onChange,
  placeholder,
  rows = 5,
  className,
  controlId,
}) => (
  <Form.Group controlId={controlId} className={classNames(styles.orderField, className)}>
    <Form.ControlLabel className={styles.orderFieldLabel}>{label}</Form.ControlLabel>
    <Input
      {...ORDER_FORM_FIELD_PROPS}
      as="textarea"
      rows={rows}
      className={classNames(styles.rsControl, styles.rsTextarea)}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  </Form.Group>
);

export default OrderLabeledTextarea;
